import { useQuery } from '@tanstack/react-query';
import ApiService from '../services/api.service';

export interface SnowflakeColumnOption {
  name: string;
  type: string;
  primary_key: string;
}

export type ListRecordsResponse<T> = {
  records: T[];
  total_pages?: number;
  total_records?: number;
};

export function useSourceColumns(pipelineNodeId: string | null | undefined) {
  return useQuery<SnowflakeColumnOption[]>({
    queryKey: ['pipeline_node_source_columns', pipelineNodeId],
    queryFn: async () => {
      if (!pipelineNodeId) {
        return [];
      }
      const results = await ApiService.getInstance().request(
        'GET',
        `/pipelinenodes/${pipelineNodeId}/source-columns`
      ) as ListRecordsResponse<SnowflakeColumnOption>;
      return results.records;
    },
    enabled: !!pipelineNodeId,
    staleTime: 60 * 1000 * 5, // 5 minutes
  });
}

